
import moment from 'moment';
import React, { useContext } from 'react';
import count_days from '../../../../functions/count_days';

import view_apartment_type_ar from '../../../../functions/view_apartment_type';
import view_day_ar from '../../../../functions/view_day_ar';
import FooterInvoice from '../../../invoice/FooterInvoice';
import HeaderInvoice from '../../../invoice/HeaderInvoice';
import { InvoiceContext } from './Invoice_Context';
import './invoice.css';

function InvoicePaymentsDates({ date_from, date_to }) {
    const data = useContext(InvoiceContext)
    const datasort = data;
    return (
        <div className='col-md-12'>
            <div id="invoice" className="page-content fade-in-up" dir="rtl" style={{ padding: "10px" }}>
                <div >
                    <div className="invoice-header">
                        <div className="row">
                            <div className="col-12">
                                <HeaderInvoice title={
                                    <>
                                        مدفوعات عــن طــريق الحــولات المصــرفية
                                        <hr></hr>
                                        {
                                            date_from ?
                                                <>
                                                    مــن   {" " + moment(date_from).format("DD-MM-Y")}
                                                </>
                                                : null
                                        }
                                        {
                                            date_to ?
                                                <span className='mr-2'>
                                                    إلــى  {" " + moment(date_to).format("DD-MM-Y")}
                                                </span>
                                                : null
                                        }
                                    </>
                                } />
                            </div>
                        </div>
                    </div>
                    <table className="table table-bordered table-striped no-margin table-invoice" style={{ fontSize: "16px" }}>
                        <thead className="color-view bg- ">
                            <tr >
                                <th style={{ fontSize: "15px" }} colSpan={2}>إجمالي الفواتير</th>
                                <th style={{ fontSize: "15px" }} colSpan={3}>إجمالي الأشخاص</th>


                                {
                                    datasort?.payment_types?.map(item => {
                                        return (
                                            <th style={{ fontSize: "15px" }}>
                                                {item.name_payment_type}
                                            </th>
                                        )
                                    })
                                }
                            </tr>
                            <tr>
                                <td colSpan={2}>{datasort?.payments?.length}</td>
                                <td colSpan={3}>{datasort?.payments?.reduce((acc, item) => acc + (item?.number_people || 0), 0)}</td>
                                {
                                    datasort?.payment_types?.map(item => {
                                        return (
                                            <td style={item.total_amount < 0 ? { fontSize: "15px", color: "red" } : item.total_amount > 0 ? { fontSize: "15px", color: "green" } : { fontSize: "15px" }}>
                                                {Intl.NumberFormat("en-US").format(item.total_amount)} د.ل
                                            </td>
                                        )
                                    })
                                }
                            </tr>
                        </thead>
                        {/* <thead className="color-view bg- ">
                            <tr >
                                <th style={{fontSize:"16px"}}>عدد الفواتير</th>
                                <th style={{fontSize:"16px"}}>إجمالي الدفع بالبطاقة</th>
                                <th style={{fontSize:"16px"}}>إجمالي الدفع نقدي</th>
                                <th style={{fontSize:"16px"}}>إجمالي المبلغ</th>
                            </tr>
                            <tr >
                                <td >{datasort.length}</td>
                                {
                                sum_amount_by_payment_type(datasort,2)+sum_amount_by_payment_type(datasort,3)<0?
                                (<td style={{color:"red"}}>{Intl.NumberFormat("en-US").format(sum_amount_by_payment_type(datasort,2)+sum_amount_by_payment_type(datasort,3))}  د.ل</td>)
                                :
                                <td style={{color:"green"}}>{Intl.NumberFormat("en-US").format(sum_amount_by_payment_type(datasort,2)+sum_amount_by_payment_type(datasort,3))}  د.ل</td>
                                }
                                {
                                sum_amount_by_payment_type(datasort,1)<0?
                                (<td style={{color:"red"}}>{Intl.NumberFormat("en-US").format(sum_amount_by_payment_type(datasort,1))}  د.ل</td>)
                                :
                                <td style={{color:"green"}}>{Intl.NumberFormat("en-US").format(sum_amount_by_payment_type(datasort,1))}  د.ل</td>
                                }
                                    {
                                sum_amount(datasort)<0?
                                (<td style={{color:"red"}}>{Intl.NumberFormat("en-US").format(sum_amount(datasort))}  د.ل</td>)
                                :
                                <td style={{color:"green"}}>{Intl.NumberFormat("en-US").format(sum_amount(datasort))}  د.ل</td>
                                }

                            </tr>

                        </thead> */}
                    </table>
                    <div class="table-responsive">
                        <table className="table table-bordered table-striped no-margin table-invoice">
                            <thead className="color-view bg- " >
                                <tr >
                                    <th style={{ fontSize: "12px", minWidth: "100px" }}>التوقيت</th>
                                    <th style={{ fontSize: "12px" }}>رقم الفاتورة</th>

                                    <th style={{ fontSize: "12px" }}>العميل</th>
                                    <th style={{ fontSize: "12px" }}>الحجز</th>
                                    <th style={{ fontSize: "12px" }}>الإقامة</th>
                                    {/* <th style={{ fontSize: "12px", minWidth: "100px" }}>تـاريخ الحجز</th> */}
                                    {/* <th style={{ fontSize: "12px" }}>الأشخاص</th> */}

                                    {/* <th style={{ fontSize: "12px" }}>أيام</th> */}
                                    <th style={{ fontSize: "12px" }}>السعر</th>
                                    <th style={{ fontSize: "12px" }}>العملية</th>
                                    <th style={{ fontSize: "12px" }}>المدفوع</th>
                                    <th style={{ fontSize: "12px" }}>نوع الدفع</th>
                                    {/* <th style={{fontSize:"12px"}}>حالته</th> */}
                                    <th style={{ fontSize: "12px" }}>المستخدم</th>

                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "13px" }}>
                                {
                                    datasort?.payments?.map((payment) => {
                                        return (
                                            <>
                                                <tr>
                                                    <td style={{ minWidth: "100px" }} >
                                                        <strong >
                                                            {moment(payment.date_payment).format('yyyy-MM-DD')}
                                                            <br></br>
                                                            {moment(payment.date_payment).format('hh:mm A')}
                                                        </strong>
                                                    </td>
                                                    <td>{payment?.ID_payment} </td>

                                                    <td>{payment?.visitor_name}</td>
                                                    <td>{payment?.ID_reservation} </td>
                                                    <td>
                                                        <strong >
                                                            {
                                                                payment?.reservation_type === 'service' ?
                                                                    <span> {payment?.service_name_ar ?? '-'}</span> :
                                                                    <span>{view_apartment_type_ar(payment.type)} - {payment.number}</span>
                                                            }
                                                        </strong>
                                                    </td>
                                                    {/* <td >{payment?.date_check_in}
                                                        {
                                                            payment?.date_check_in !== payment?.date_check_out ?
                                                                <>
                                                                    <br></br>
                                                                    {payment?.date_check_out}
                                                                </>
                                                                : null
                                                        }
                                                    </td> */}
                                                    {/* <td >
                                                        <strong >
                                                            {payment?.number_people ? <>{payment?.number_people}<i className="pi pi-users mr-1 ml-1"></i></> : null}
                                                        </strong>
                                                    </td> */}

                                                    {/* <td >{count_days([payment])}</td> */}
                                                    <td><strong >{Intl.NumberFormat("en-US").format(payment?.total_price)} د.ل</strong></td>
                                                    <td><strong >{payment?.operation_type}</strong></td>
                                                    <td>
                                                        {
                                                            payment.amount >= 0 ?
                                                                (
                                                                    <strong style={{ color: "green" }}>{Intl.NumberFormat("en-US").format(payment?.amount)} د.ل</strong>
                                                                )
                                                                :
                                                                (
                                                                    <strong style={{ color: "red" }}>{Intl.NumberFormat("en-US").format(payment?.amount)} د.ل</strong>
                                                                )
                                                        }
                                                    </td>
                                                    <td>
                                                        <strong >{payment?.name_payment_type} </strong>
                                                        {
                                                            payment?.value_key ?
                                                                <><br></br>{payment?.value_key}</> : null
                                                        }
                                                        {
                                                            payment?.value_key_2 ?
                                                                <><br></br>{payment?.value_key_2}</> : null
                                                        }
                                                    </td>
                                                    {/* <td>
                                                        {
                                                            payment.del ===0?
                                                            (

                                                                    payment.total_price-payment.total_paid ===0 ?
                                                                    (
                                                                        <strong style={{color:"green"}}>
                                                                            خالص
                                                                        </strong>
                                                                    )
                                                                    :
                                                                    (
                                                                        <strong style={{color:"red"}}>
                                                                        مدفوع جزاء

                                                                        </strong>
                                                                    )
                                                            )
                                                        }

                                                        </td> */}

                                                    <td><strong >{payment?.name_user}</strong></td>
                                                </tr>
                                            </>
                                        );
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <br></br>
                <table >
                    <thead>
                        <th colSpan={5}>

                            <small style={{ margin: "5px" }}>
                                تاريخ الطباعة
                            </small>
                            -
                            <small style={{ margin: "5px" }} dir='rtl'>
                                {moment(new Date()).format("YYYY-MM-DD")}
                            </small>
                            -
                            <small style={{ margin: "5px" }} dir='ltr'>
                                {moment(new Date()).format("LT")}
                            </small>
                        </th>
                    </thead>
                </table>
                <FooterInvoice></FooterInvoice>
            </div>
        </div>
    );
}
export default InvoicePaymentsDates;